import { Injectable } from '@angular/core';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { MobilityMapItem } from '../definitions/mobility-map-item';
import type { MobilityMapFilterKey } from '../types/mobility-map-filters';

@Injectable({ providedIn: 'root' })
export class MobilityMapMapDataService extends InjectableMapDataStateService<MobilityMapItem, MobilityMapFilterKey> {
}
